// 正则验证

export let sfzReg = /(^\d{15}$)|(^\d{6}[1,2]\d{3}((0[1-9]|1[0-2]))(([0,1,2]\d)|3[0-1])\d{3}(\d|X|x)$)/;
export let phoneReg = /^[1][0-9]{10}$/;
export let telReg = /^\d{3}-\d{7,8}|\d{4}-\d{7,8}$/;
export let emailReg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
export let bankCardhReg = /^([0-9]{1})(\d|-)*$/; // 银行卡
